import React, {Fragment} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSqftCroppedSlabImages,
  setActiveStep,
  setActiveSlabUrl, setSlabImageHeight, setSlabImageWidth, addSqftCroppedSlabImage, setIsSizeValidationFailed,
} from "../../../../actions/sqftSlabFunctions";

import {SLAB_IMAGE_TYPES} from "../../../../reducers/sqftSlabReducer";
//import workspace from "../canvas/core/workspace";
//import sqftEventManager from "../canvas/store/sqftEventManager";
import sqftShapeManager from "../canvas/store/sqftShapeManager";
import sqftConfig from "../canvas/store/sqftConfig";

const SqftLoadSlabFooterSelectImageTypeButtons = (props) => {
  const {setSQFTActiveButton, setIsSizeValidationFailed} = props;
  const {slabImageType} = props;
  const {slabImageWidth, slabImageHeight} = props;
  const {activeStep, setActiveStep} = props;

  const closePopup = () => {
    setSQFTActiveButton("");
  }

  // const addPlaceholderImage = () => {
  //   const croppedImage = new Image();
  //   croppedImage.src = '/images/sqft-icons/placeholder.png';
  //
  //   let workspaceImage = workspace.addImage(
  //     croppedImage,
  //     slabImageWidth,
  //     slabImageHeight,
  //     null,
  //     null,
  //     "slabImage",
  //     function () {},
  //     null,
  //     null,
  //     null,
  //     sqftEventManager.priorities.SLAB_IMAGE,
  //   );
  //   addSqftCroppedSlabImage(workspaceImage);
  // }

  const addPlaceholderShape = () => {
    sqftShapeManager.addPlaceholderShape(
      +slabImageWidth / sqftConfig.getMeasureMultiplier(),
      +slabImageHeight / sqftConfig.getMeasureMultiplier(),
    );
  }

  const handlePlaceholderClick = () => {
    if (!slabImageWidth || !slabImageHeight) {
      setIsSizeValidationFailed(true);
      return
    }

    setIsSizeValidationFailed(false);
    addPlaceholderShape();
    closePopup();
  }

  return (
    <Fragment>
      {
        activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.placeholder ?
          <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes"
                  onClick={() => {handlePlaceholderClick()}}>
              <span className="ui-button10-text ui-button10--uppercase">
                <FormattedMessage id={"sqft.popup.slabmode.upload"}/>
              </span>
          </button>
          : null
      }
      {
        activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.upload  ?
          <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes"
                  onClick={() => {setActiveStep(activeStep + 1)}}>
              <span className="ui-button10-text ui-button10--uppercase">
                <FormattedMessage id={"sqft.popup.slab.next"}/>
              </span>
          </button>
          : null
      }
    </Fragment>

  )
};

const mapStateToProps = (store) => ({
  activeSlabId: store.sqftSlabState.activeSlabId,
  activeStep: store.sqftSlabState.activeStep,
  slabImageWidth: store.sqftSlabState.slabImageWidth,
  slabImageHeight: store.sqftSlabState.slabImageHeight,
  pricePerArea: store.sqftSlabState.pricePerArea,
  activeButton: store.sqftMenuState.activeButton,
  slabImageType: store.sqftSlabState.slabImageType,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveStep,
  setActiveSlabUrl,
  setSqftCroppedSlabImages,
  setSlabImageHeight,
  setSlabImageWidth,
  addSqftCroppedSlabImage,
  setIsSizeValidationFailed,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabFooterSelectImageTypeButtons)
)

